import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComplaint = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			rx: 12,
			fill: "#FFE9E9"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .8,
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.9384 12.1387H33.972C36.8198 12.1387 39.2391 14.0236 40.016 16.6116C40.0864 16.8462 39.9037 17.0731 39.6587 17.0731H26.772C21.972 17.0731 18.0552 20.9899 18.0552 25.8091V34.5463C18.0552 34.7792 17.849 34.9593 17.6211 34.9113C14.7636 34.3105 12.6216 31.7629 12.6216 28.7275V18.4555C12.6216 14.9803 15.4632 12.1387 18.9384 12.1387Z",
				fill: "url(#paint0_linear_22641_41550)"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M41.8066 19.9736H26.7725C23.5746 19.9739 20.9561 22.5905 20.9561 25.8096V36.082C20.9563 39.2807 23.5738 41.8982 26.7725 41.8984H28.3662C29.2247 41.8984 30.0441 42.2369 30.6396 42.8516L32.7529 44.9629C33.1837 45.3745 33.7308 45.6035 34.2998 45.6035C34.8733 45.6034 35.4188 45.3712 35.8271 44.9629L37.9395 42.8516C38.5508 42.2402 39.3691 41.8984 40.2324 41.8984H41.8066C45.0257 41.8984 47.6423 39.2799 47.6426 36.082V25.8096C47.6426 22.6919 45.1859 20.138 42.1064 19.9814L41.8066 19.9736ZM39.0801 28.7275C40.4505 28.7275 41.577 29.8532 41.5771 31.2236C41.5771 32.6004 40.4443 33.7012 39.0801 33.7012C37.7096 33.7011 36.6025 32.5941 36.6025 31.2236C36.6027 29.8596 37.7034 28.7276 39.0801 28.7275ZM30.0947 28.7275C31.4713 28.7276 32.5721 29.8596 32.5723 31.2236C32.5723 32.5941 31.4652 33.7011 30.0947 33.7012C28.7305 33.7012 27.5977 32.6004 27.5977 31.2236C27.5978 29.8532 28.7243 28.7275 30.0947 28.7275Z",
				fill: "url(#paint1_linear_22641_41550)",
				stroke: "url(#paint2_linear_22641_41550)"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_22641_41550",
				x1: 11.5,
				y1: 9.5,
				x2: 45,
				y2: 45.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F13308" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFBDAF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_22641_41550",
				x1: 22,
				y1: 19,
				x2: 59.5,
				y2: 54.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FE7F5F" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F13308"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_22641_41550",
				x1: 34.2994,
				y1: 46.104,
				x2: 34,
				y2: 12.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FEB09B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFD7D7"
				})]
			})
		] })
	]
});
export default SvgComplaint;
